import React, { useEffect } from 'react';

const StripePricingTable = () => {
  useEffect(() => {
    // Carrega o script do Stripe dinamicamente
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    // Limpa o script quando o componente é desmontado
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <stripe-pricing-table
      pricing-table-id="prctbl_1RTZElHXaWJDqPQaBTRlKkN2"
      publishable-key="pk_live_51N6gbZHXaWJDqPQasaAFB0mSNQf5YuM4GsRmO53aYvjFF4AvVmWcViiXcgmLsx2DuqWNFuyIXus9aSlXbqvoPbDS00WdLVmmHz"
    ></stripe-pricing-table>
  );
};

export default StripePricingTable;
